
import axios from "axios"

export function getRecallDealerDropdown (params) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/recall/get-dealer-dropdown`, {params})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};